import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/devices',
    name: 'Device',
    component: {
      name: 'AdminDevice',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'device',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminDeviceIndex',
        component: () => import('../views/DevicesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminDeviceNew',
        component: () => import('../views/DeviceInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminDeviceIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminDeviceShow',
        component: () => import('../views/DeviceShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminDeviceIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminDeviceDetails',
            component: () => import('../views/DeviceDetails.vue'),
            meta: {
              backRoute: { name: 'AdminDeviceIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminDeviceEdit',
            component: () => import('../views/DeviceInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminDeviceDetails' },
            },
          },
          {
            path: 'settings',
            name: 'AdminDeviceSettings',
            component: () => import('../views/settings/DeviceSettingsDetails.vue'),

            meta: {
              backRoute: { name: 'AdminDeviceIndex' },
              resource: 'setting',
            },
          },
          {
            path: 'settings/edit_settings',
            name: 'AdminDeviceSettingsEdit',
            component: () => import('../views/settings/DeviceSettingsInput.vue'),
            meta: {
              action: 'edit',
              customName: 'general.edit_settings',
              backRoute: { name: 'AdminDeviceSettings' },
            },
          },
          {
            path: 'device_messages',
            name: 'DeviceDeviceMessages',
            component: {
              render(h) {
                return h('router-view');
              },
            },
            meta: {
              backRoute: { name: 'AdminDeviceIndex' },
              resource: 'device_message',
            },
            get redirect() {
              return this.children[0];
            },
            children: [
              {
                path: '',
                name: 'AdminDeviceDeviceMessages',
                component: () => import('../views/deviceMessage/DeviceMessages.vue'),
                meta: {
                  backRoute: { name: 'AdminDeviceIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminDeviceDeviceMessageNew',
                component: () => import('../views/deviceMessage/DeviceMessageInput.vue'),
                meta: {
                  action: 'new',
                  resource: 'device_message',
                  backRoute: { name: 'AdminDeviceDeviceMessages' },
                },
              },
              {
                path: ':deviceMessageId(\\d+)',
                name: 'AdminDeviceDeviceMessageshow',
                component: () => import('../views/deviceMessage/DeviceMessageShow.vue'),
                meta: {
                  resource: 'device_message',
                  backRoute: { name: 'AdminDeviceDeviceMessages' },
                  tArgs: route => ({ name: route?.params?.id }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminDeviceDeviceMessageDetails',
                    component: () => import('../views/deviceMessage/DeviceMessageDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminDeviceDeviceMessages' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminDeviceDeviceMessageEdit',
                    component: () => import('../views/deviceMessage/DeviceMessageInput.vue'),
                    meta: {
                      action: 'edit',
                      resource: 'device_message',
                      backRoute: { name: 'AdminDeviceDeviceMessages' },
                    },
                  },
                ],
              },
            ]
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));